import { createSlice } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IClone } from "src/@types/clones";
import { CLONES_SLICE_NAME } from "./actions";
import { getClonesReducer, getTrandingClonesReducer } from "./reducers";

interface IClonesObjectWithResponse {
  isLoading: boolean;
  data: IResponseWithPagination<IClone>;
}

export interface ClonesState {
  clones: IClonesObjectWithResponse;
  trandingClones: IClonesObjectWithResponse;
}

const initialState: ClonesState = {
  clones: {
    isLoading: false,
    data: null,
  },
  trandingClones: {
    isLoading: false,
    data: null,
  },
};

export const { reducer: clones } = createSlice({
  name: CLONES_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getClonesReducer(builder);
    getTrandingClonesReducer(builder);
  },
});
